export default __webpack_public_path__ + "b038895b1cd5ebba611bfa2e1cef1e44.svg";